/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_8Inputs */



/**
* | output |
* | --- |
* | "Desktop installer for Windows, Mac, and Linux" |
*
* @param {Signup_Feature_Starter_8Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_8 = /** @type {((inputs?: Signup_Feature_Starter_8Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_8Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Desktop installer for Windows, Mac, and Linux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Desktop installer for Windows, Mac, and Linux")
	if (locale === "it") return /** @type {LocalizedString} */ ("Desktop installer for Windows, Mac, and Linux")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Desktop installer for Windows, Mac, and Linux")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desktop installer for Windows, Mac, and Linux")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Desktop installer for Windows, Mac, and Linux")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Desktop installer for Windows, Mac, and Linux")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Desktop installer for Windows, Mac, and Linux")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desktop installer for Windows, Mac, and Linux")
	return /** @type {LocalizedString} */ ("Desktop installer for Windows, Mac, and Linux")
});